import React from 'react';

const BrandingFooter = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-gray-900 text-gray-400 py-1 text-center text-xs z-40">
      <p>Powered By More Than Technology LLC</p>
    </footer>
  );
};

export default BrandingFooter;